import { IconArrowBoldUp16, IconArrowBoldDown16 } from '@cian/ui-kit';
import { ReactElement } from 'react';
import { EDiffPriceTrand } from 'shared/repositories/valuation-offer-history/entities/market_trand/GetMarketTrandResponseSchema';

interface IUseGetDiffParams {
  diffPriceTrand: EDiffPriceTrand;
  diffPrice: string | null;
  diffPercent: string | null;
}

export interface IUseGetDiffReturnValue {
  text: string;
  icon: ReactElement | null;
  diffPercent: string | null;
}

const initialState = {
  text: '+0 ₽',
  icon: null,
  diffPercent: '+0%',
};

export function useGetDiff({ diffPriceTrand, diffPrice, diffPercent }: IUseGetDiffParams): IUseGetDiffReturnValue {
  switch (diffPriceTrand) {
    case EDiffPriceTrand.Increase:
      return {
        text: `+${diffPrice}` as string,
        icon: <IconArrowBoldUp16 color="primary_100" />,
        diffPercent: `+${diffPercent}`,
      };
    case EDiffPriceTrand.Decrease:
      return {
        text: `−${diffPrice}` as string,
        icon: <IconArrowBoldDown16 color="primary_100" />,
        diffPercent: `−${diffPercent}`,
      };
    default:
      return initialState;
  }
}
